export class ApplicationExceptionSearchModel {
  id: string;
  name: string;
  reason: string;
  exceptions: string;
}
